import { useMutation, useQueryClient } from "react-query";
import axios from '../axios';

const useAddRequest = ({onSuccess, onError}) => {
  const queryClient = useQueryClient();
  const mutation = useMutation(
    async (params) => {
      return await axios.post("/api/requests", {
        request_type: params.request_type,
        description: params.description,
        requested_by: params.requested_by
      }) 
    },
    {
      onSuccess: (res) => {
        queryClient.invalidateQueries("requests");
        onSuccess(res);
      },
      onError: (err) => onError(err)
    }
  )

  return mutation;
}

export default useAddRequest;